export default __webpack_public_path__ + "static/media/sample.eedaa7a1.pdf";